import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { BagQRPrintFiltering } from './Pages';

export const BagQRCodeRePrintRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={BagQRPrintFiltering} />
    </Fragment>
)